import { FP_VOUCHER_TYPES } from "../../../../common/const/free_play_consts";
import { IFreePlayVoucherDelta } from "../../../../common/interfaces/free-play/free-play-voucher-data.interface";
import { IFreePlayGameViewModel } from "../free-play-game/free-play-game-view-model.interface";
import {IFreePlayVoucherModel} from "./free-play-voucher.model.interface";

export class VoucherForUiDisplayModel implements IFreePlayVoucherModel {
    constructor(private readonly innerVoucher: IFreePlayVoucherModel) {

    }

    get isValid(): boolean {
        return this.innerVoucher.isValid && this.freePlayGames.length > 0;
    }
    updateVoucherData(voucherData: IFreePlayVoucherDelta): void {
        this.innerVoucher.updateVoucherData(voucherData);
    }
    hasGame(gameType: number): boolean {
        return Boolean(this.freePlayGames.find(g => g.gameInfo.gameType === gameType));
    }
    dispose(): void {
        this.innerVoucher.dispose()
    }
    get creationDate(): Date {
        return this.innerVoucher.creationDate;
    }
    get expirationDate(): Date {
        return this.innerVoucher.expirationDate;
    }
    get id(): string {
        return this.innerVoucher.id
    }
    get freePlayType(): FP_VOUCHER_TYPES {
        return this.innerVoucher.freePlayType;
    }
    get originalAmount(): number {
        return this.innerVoucher.originalAmount;
    }
    get formattedOriginalAmount(): string {
        return this.innerVoucher.formattedOriginalAmount;
    }
    get currentBalance(): number {
        return this.innerVoucher.currentBalance;
    }
    get formattedCurrentBalance(): string {
        return this.innerVoucher.formattedCurrentBalance;
    }
    get isCloseToExpiration(): boolean {
        return this.innerVoucher.isCloseToExpiration;
    }
    get expirationMessage(): string {
        return this.innerVoucher.expirationMessage;
    }
    get voucherName(): string {
        return this.innerVoucher.voucherName;
    }
    get voucherInGameTitle(): string {
        return this.innerVoucher.voucherInGameTitle;
    }
    get voucherDescription(): string {
        return this.innerVoucher.voucherDescription;
    }
    get freePlayGames(): IFreePlayGameViewModel[] {
        //When displaying the voucher in user menu or anywhere in the UI, for both 3rd party and 888 vouchers we filter the games based on the voucher remaining amount and game minimum bet
        return this.innerVoucher.freePlayGames.filter(fpg => fpg.hasEnoughBalanceToBet);
    }
    get backgroundImageUrl(): string {
        return this.innerVoucher.backgroundImageUrl;
    }
    get iconUrl(): string {
        return this.innerVoucher.iconUrl;
    }
    get isThirdPartyVoucher(): boolean {
        return this.innerVoucher.isThirdPartyVoucher;
    }
}